export interface HotkeyDefinition {
  key: string;
  metaKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
}

const matchesModifier = (
  expected: boolean | undefined,
  actual: boolean
) => expected === undefined || expected === actual;

export const matchesHotkey = (
  event: KeyboardEvent,
  hotkey: HotkeyDefinition
) =>
  event.key.toLowerCase() === hotkey.key.toLowerCase() &&
  matchesModifier(hotkey.metaKey, event.metaKey) &&
  matchesModifier(hotkey.ctrlKey, event.ctrlKey) &&
  matchesModifier(hotkey.shiftKey, event.shiftKey);

export const HotkeyManager = {
  matches: matchesHotkey,
};
